/**
 * @generated SignedSource<<12340b7409f6ca68b11d85e3986c5713>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProposalStatus = "ACTIVE" | "CANCELLED" | "DEFEATED" | "EXECUTED" | "EXPIRED" | "OBJECTION_PERIOD" | "PENDING" | "QUEUED" | "UPDATABLE" | "VETOED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CastVoteInputFragment$data = {
  readonly description: string;
  readonly status: ProposalStatus;
  readonly " $fragmentType": "CastVoteInputFragment";
};
export type CastVoteInputFragment$key = {
  readonly " $data"?: CastVoteInputFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CastVoteInputFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CastVoteInputFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};

(node as any).hash = "1cb7d4b1a9dd32ef32fe61b93cb3b43a";

export default node;
